export default __webpack_public_path__ + "static/media/car03.0b89bcf0.jpg";